import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'displayvalue',
    templateUrl: 'displayvalue.component.html',
    styleUrls: ['displayvalue.component.scss'],
})
export class DisplayValueComponent implements OnInit {

  @Input() public dataLineList;
  @Input() public scroll = false;
  @Input() public title = '';

  public ngOnInit() {

  }

}
